<template>
  <div class="contactUs_main">
    <div class="page-banner bg_">
      <!-- <img src="../assets/pcImg/abouetbanner.jpg" alt /> -->
      <img :src="subBannerImgurl" alt />
    </div>
    <div class="contactUs_body">
      <div class="tab_list">
        <img src="../assets/pcImg/company/tabbg.png" alt class="tab_img" />
        <div class="all_c">
          <div class="intro_" @click="myTab(0)">
            <img src="../assets/pcImg/contact/contacticon.png" alt />
            联系我们
          </div>
          <div class="history_" @click="myTab(1)">
            <img src="../assets/pcImg/contact/partnericon.png" alt />
            合作伙伴
          </div>
        </div>
        <div class="light_line" :class="tab == 1 ? 'two_line' : ''"></div>
      </div>
      <div class="contact_tab" v-if="tab == 0">
        <div class="contact_email">
          <div class="email" v-for="(item, index) in emailList" :key="index">
            <img src="../assets/pcImg/contact/email.png" alt class="email_img" :class="[index ==0 || index==1 ? 'animate__animated animate__fadeInDown' : 'animate__animated animate__fadeInUp']" />
            <p class="email_name" :class="[index==0 || index ==1?'animate__animated animate__fadeInDown' : 'animate__animated animate__fadeInUp']">{{ item.name }}</p>
            <div class="email_address" :class="[index==0 || index ==1?'animate__animated animate__fadeInDown' : 'animate__animated animate__fadeInUp']">{{ item.address }}</div>
          </div>
        </div>
        <div class="contact_map">
          <div class="map_item animate__animated animate__fadeInLeft">
            <img src="../assets/pcImg/contact/suzhou.png" alt class="title animate__animated animate__fadeInUp" />
            <div class="text animate__animated animate__fadeInUp">
              <em class="address"></em>
              <span>
                地址 :
                中国（江苏）自由贸易试验区苏州片区苏州工业园区金尚路1号仙峰大厦南楼8-10层
              </span>
            </div>
            <div class="text animate__animated animate__fadeInUp">
              <em class="linkman"></em>
              <span>联系人 : Chen</span>
            </div>
            <div class="text animate__animated animate__fadeInUp">
              <em class="email"></em>
              <span>邮箱 : helloworld@iclockwork.com</span>
            </div>
            <div class="text animate__animated animate__fadeInUp">
              <em class="phone"></em>
              <span>电话 : 0512-81880728</span>
            </div>
          </div>
          <div class="map animate__animated animate__fadeInRight" id="map">
            <div style="border:#ccc solid 1px;" class="baidumap" id="allmap"></div>
            <!-- <img src="../assets/pcImg/contact/map.png" alt /> -->
          </div>
          <!-- <div class="map_item">
              <img src="../assets/pcImg/contact/xianggang.png" alt class="title" />
              <div class="text">
                <em class="address"></em>
                <span>地址 : 苏州市工业园区若水路388号苏州纳米技术国家大学科技园E栋303室</span>
              </div>
              <div class="text">
                <em class="linkman"></em>
                <span>联系人 : Chen</span>
              </div>
              <div class="text">
                <em class="email"></em>
                <span>邮箱 : helloworld@iclockwork.com</span>
              </div>
              <div class="text">
                <em class="phone"></em>
                <span>电话 : 0512-81880728</span>
              </div>
            </div>
            <div class="map_item">
              <img src="../assets/pcImg/contact/shouer.png" alt class="title" />
              <div class="text">
                <em class="address"></em>
                <span>地址 : 苏州市工业园区若水路388号苏州纳米技术国家大学科技园E栋303室</span>
              </div>
              <div class="text">
                <em class="linkman"></em>
                <span>联系人 : Chen</span>
              </div>
              <div class="text">
                <em class="email"></em>
                <span>邮箱 : helloworld@iclockwork.com</span>
              </div>
              <div class="text">
                <em class="phone"></em>
                <span>电话 : 0512-81880728</span>
              </div>
          </div>-->
        </div>
      </div>
      <div class="partner_tab" v-else>
        <div class="partner_dom">
          <img src="../assets/pcImg/contact/kaisa.png" alt class="partner_item animate__animated animate__fadeInUp animate__delay-01s" />
          <img src="../assets/pcImg/contact/xianfeng.png" alt class="partner_item animate__animated animate__fadeInUp animate__delay-02s" />
          <img src="../assets/pcImg/contact/zhangqu.png" alt class="partner_item animate__animated animate__fadeInUp animate__delay-03s" />
          <img src="../assets/pcImg/contact/nippon.png" alt class="partner_item animate__animated animate__fadeInUp animate__delay-04s" />

          <img src="../assets/pcImg/contact/winjoy.png" alt class="partner_item animate__animated animate__fadeInUp animate__delay-05s" />
          <img src="../assets/pcImg/contact/youai.png" alt class="partner_item animate__animated animate__fadeInUp animate__delay-06s" />
          <img src="../assets/pcImg/contact/mobai.png" alt class="partner_item animate__animated animate__fadeInUp animate__delay-07s" />
          <img src="../assets/pcImg/contact/dalan.png" alt class="partner_item animate__animated animate__fadeInUp animate__delay-08s" />

          <img src="../assets/pcImg/contact/shangyou.png" alt class="partner_item animate__animated animate__fadeInUp animate__delay-09s" />
          <img src="../assets/pcImg/contact/youjia.png" alt class="partner_item animate__animated animate__fadeInUp animate__delay-10s" />
          <img src="../assets/pcImg/contact/facebook.png" alt class="partner_item animate__animated animate__fadeInUp animate__delay-11s" />
          <img src="../assets/pcImg/contact/google.png" alt class="partner_item animate__animated animate__fadeInUp animate__delay-12s" />
          <img src="../assets/pcImg/contact/tiktok.png" alt class="partner_item animate__animated animate__fadeInUp animate__delay-13s" />
          <img src="../assets/pcImg/contact/unity.png" alt class="partner_item animate__animated animate__fadeInUp animate__delay-14s" />
        </div>
        <div class="parner_text">注：合作伙伴排序不分先后</div>
      </div>
    </div>
    <loading v-if="loading" class="loading"></loading>
  </div>
</template>
<script>
import Loading from './loading'
export default {
  components: {
    Loading,
  },
  data() {
    return {
      tab: 0,
      emailList: [
        {
          name: '市场合作 (渠道)',
          address: 'marketing@iclockwork.com',
        },
        {
          name: 'PR合作',
          address: 'marketing@iclockwork.com',
        },
        {
          name: '商务合作 (产品)',
          address: 'business@iclockwork.com',
        },
        {
          name: '本地化及翻译合作',
          address: 'business@iclockwork.com',
        },
      ],
      subBannerImgurl: '',
      loading: true,
      position_NKYYGS: {
        Name: '苏州爱洛克信息技术有限公司',
        address:
          '中国（江苏）自由贸易试验区苏州片区苏州工业园区金尚路1号仙峰大厦南楼8-10层',
        phoneNumber: '0512-81880728',
        bdLNG: 120.778922,
        bdLAT: 31.274513,
      },
    }
  },
  mounted: function () {
    this.getSubBannerImgurl()
    this.baiduMap()
  },
  computed: {},
  watch: {
    getUserLangs(val) {},
  },
  methods: {
    baiduMap: function () {
      var map = new BMap.Map('allmap')
      map.enableScrollWheelZoom(true)
      map.addControl(new BMap.NavigationControl())
      map.addControl(new BMap.ScaleControl())
      map.addControl(new BMap.OverviewMapControl())
      map.addControl(new BMap.MapTypeControl())
      map.clearOverlays()
      var sContent =
        '<div style="width:300px;"><p style="font-size:16px;font-weight:bold;margin-top: 10px;color:#f08200">' +
        this.position_NKYYGS.Name +
        '</p><p style="font-size:13px;margin: 5px 0;">地址：' +
        this.position_NKYYGS.address +
        '</p><p style="font-size:13px;margin: 5px 0;">电话：' +
        this.position_NKYYGS.phoneNumber +
        '</p><p style="font-size:13px;margin: 5px 0;">坐标：' +
        this.position_NKYYGS.bdLNG +
        ',' +
        this.position_NKYYGS.bdLAT
      ;('</div>')
      var point = new BMap.Point(
        this.position_NKYYGS.bdLNG,
        this.position_NKYYGS.bdLAT
      )
      var marker = new BMap.Marker(point)
      map.addOverlay(marker)
      map.centerAndZoom(point, 18)
      var infoWindow = new BMap.InfoWindow(sContent)
      marker.addEventListener('click', function () {
        this.openInfoWindow(infoWindow)
      })
    },
    getSubBannerImgurl: function () {
      let datas = {
        position: 5,
      }
      this.getHttp(this, datas, '/front/page/banner', function (obj, data) {
        if (data.status == 2000) {
          obj.loading = false
          obj.subBannerImgurl = data.data[0].img_url
        } else {
          console.log(data.message)
        }
        obj.loading = false
      })
    },
    myTab: function (e) {
      this.tab = e
      if (e == 0) {
        console.log('e0', e)
        this.$nextTick(() => {
          this.baiduMap()
        })
      }
    },
    map: function () {
      var map = new BMap.Map('map') // 创建地图实例
      var point = new BMap.Point(120.743698, 31.264052) // 创建点坐标
      var marker = new BMap.Marker(point) // 创建标注
      map.addOverlay(marker)
      map.centerAndZoom(point, 20)
      var opts = {
        offset: {
          width: 0,
          height: -30,
        },
        width: 450,
        height: 100, // 信息窗口高度
        title: '苏州爱洛克信息技术有限公司',
      }
      var infoWindow = new BMap.InfoWindow()
      map.setZoom(18)
      map.openInfoWindow(infoWindow, point)
      marker.setAnimation(BMAP_ANIMATION_BOUNCE)
      map.enableScrollWheelZoom(true) //开启鼠标滚轮缩放
    },
  },
}
</script>
<style lang="scss" scoped>
.baidumap {
  width: 100%;
  height: 100%;
}
.contactUs_main {
  width: 100%;
  background: #1d222c !important;
}
.page-banner {
  width: 100%;
  height: 0;
  padding-bottom: 32.38%;
  position: relative;
  background: #202630;
}
.page-banner img {
  width: 100%;
}
.tab_list {
  width: 100%;
  height: 0.83rem;
  position: absolute;
  top: 0;
  z-index: 2;
  .tab_img {
    width: 100%;
    display: block;
    height: 0.83rem;
  }
  .all_c {
    width: 8rem;
    position: absolute;
    left: 50%;
    top: 0;
    margin-left: -4rem;
    height: 0.83rem;
  }
  .intro_,
  .history_,
  .team_ {
    width: 50%;
    height: 0.83rem;
    line-height: 0.83rem;
    font-size: 0.21rem;
    color: white;
    position: absolute;
    left: 50%;
    top: 0;
    text-align: center;
    cursor: pointer;
  }
  .intro_ {
    left: 0;
    img {
      width: 0.26rem;
      margin-right: 0.05rem;
    }
  }
  .history_ {
    right: 0;
    img {
      width: 0.26rem;
      margin-right: 0.05rem;
    }
  }
  .team_ {
    margin-left: 2rem;
    img {
      width: 0.26rem;
      margin-right: 0.05rem;
    }
  }
  .light_line {
    width: 2.01rem;
    height: 0.03rem;
    background-color: chocolate;
    position: absolute;
    bottom: 0;
    left: 50%;
    margin-left: -2.99rem;
    border-radius: 1.5px;
    transition: margin-left 0.5s ease;
  }
  .two_line {
    margin-left: 1.01rem;
  }
  .three_line {
    margin-left: 3.35rem;
  }
}
.contact_tab {
  width: 100%;
  min-height: 15.25rem;
  background: url('../assets/pcImg/contect_bg.jpg') no-repeat;
  background-size: 100% 100%;
}
.contactUs_body {
  position: relative;
  width: 100%;
  overflow-x: hidden;
  min-height: 5.25rem;
  background-color: #161822;
  display: flex;
  align-items: stretch;
  flex-flow: row wrap;
  .contact_email {
    width: 12rem;
    height: 3.4rem;
    position: absolute;
    top: 2.1rem;
    left: 50%;
    margin-left: -6rem;
    display: flex;
    flex-flow: row nowrap;
    .email {
      width: 25%;
      box-sizing: border-box;
      border-right: 1px solid #a5a7ac;
      background: rgba(255, 255, 255, 0.1);
      .email_img {
        width: 0.85rem;
        margin: 0.7rem auto 0.65rem;
        display: block;
      }
      .email_name {
        text-align: center;
        color: white;
        font-size: 0.23rem;
        margin-top: 0rem;
        margin-bottom: 0;
      }
      .email_address {
        text-align: center;
        color: white;
        font-size: 0.17rem;
        margin-top: 0.1rem;
        margin-bottom: 0;
      }
    }
    .email:last-child {
      border-right: 0;
    }
  }
  .contact_map {
    width: 14.6rem;
    height: 3.4rem;
    position: absolute;
    top: 6.5rem;
    left: 50%;
    margin-left: -7.3rem;
    display: flex;
    flex-flow: row nowrap;
    // justify-content: space-between;
    justify-content: center;
    .map {
      width: 6.73rem;
      height: 6.64rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .map_item {
      width: 4.63rem;
      height: 6.64rem;
      .title {
        display: block;
        width: 2.34rem;
        margin: 0.5rem auto;
        transition: all 0.8s ease;
      }
      .text {
        transition: all 0.8s ease;
        span {
          display: inline-block;
          width: 88%;
        }
        .address {
          display: inline-block;
          vertical-align: top;
          margin-top: 0.1rem;
          margin-right: 0.15rem;
          width: 0.17rem;
          height: 0.23rem;
          background: url('../assets/pcImg/contact/address.png') no-repeat;
          background-size: 100% 100%;
        }
        .linkman {
          display: inline-block;
          margin-right: 0.15rem;
          width: 0.19rem;
          height: 0.21rem;
          background: url('../assets/pcImg/contact/linkman.png') no-repeat;
          background-size: 100% 100%;
        }
        .email {
          display: inline-block;
          margin-right: 0.15rem;
          line-height: 0.35rem;
          width: 0.19rem;
          height: 0.14rem;
          background: url('../assets/pcImg/contact/email_small.png') no-repeat;
          background-size: 100% 100%;
        }
        .phone {
          display: inline-block;
          margin-right: 0.15rem;
          width: 0.17rem;
          height: 0.17rem;
          background: url('../assets/pcImg/contact/phone.png') no-repeat;
          background-size: 100% 100%;
        }
        color: white;
        margin: 0 15%;
        text-align: left;
        width: 70%;
        font-size: 0.17rem;
        line-height: 0.36rem;
        margin-bottom: 0.1rem;
      }
    }
    .map_item:nth-child(1) {
      background: url('../assets/pcImg/contact/suzhou_bg.png') no-repeat;
      background-size: 100% 100%;
      transition: all 0.6s ease;
    }
    .map_item:nth-child(1):hover {
      // margin-top: -.2rem;
    }
    .map_item:nth-child(2) {
      background: url('../assets/pcImg/contact/xianggang_bg.png') no-repeat;
      background-size: 100% 100%;
      transition: all 0.6s ease;
    }
    .map_item:nth-child(2):hover {
      margin-top: -0.2rem;
    }
    .map_item:nth-child(3) {
      background: url('../assets/pcImg/contact/shouer_bg.png') no-repeat;
      background-size: 100% 100%;
      transition: all 0.6s ease;
    }
    .map_item:nth-child(3):hover {
      margin-top: -0.2rem;
    }
  }
}
.partner_tab {
  width: 100%;
  min-height: 7.88rem;
  background: url('../assets/pcImg/contact/paterbg.png') no-repeat;
  background-size: 100% 100%;
  .partner_dom {
    width: 13rem;
    height: 4.5rem;
    margin: 2rem auto 0;
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: center;
    .partner_item {
      margin-right: 0.49rem;
      margin-bottom: 0.3rem;
    }
    .partner_item:nth-child(1) {
      width: 2.08rem;
      margin-right: 0.49rem;
    }
    .partner_item:nth-child(2) {
      width: 2.65rem;
      margin-right: 0.49rem;
    }
    .partner_item:nth-child(3) {
      width: 1.74rem;
      margin-right: 0.49rem;
    }
    .partner_item:nth-child(4) {
      width: 1.8rem;
      margin-right: 0.49rem;
    }
    .partner_item:nth-child(5) {
      width: 2.12rem;
      margin-right: 0.49rem;
    }
    .partner_item:nth-child(6) {
      width: 2.06rem;
      margin-right: 0.7rem;
    }
    .partner_item:nth-child(7) {
      width: 1.72rem;
      margin-right: 0.7rem;
    }
    .partner_item:nth-child(8) {
      width: 2.12rem;
      margin-right: 0.7rem;
    }
    .partner_item:nth-child(9) {
      width: 2rem;
      margin-right: 0.7rem;
    }
    .partner_item:nth-child(10) {
      width: 1.34rem;
      margin-right: 0.7rem;
    }
    .partner_item:nth-child(11) {
      width: 2.12rem;
      margin-right: 0.8rem;
    }
    .partner_item:nth-child(12) {
      width: 2rem;
      margin-right: 0.8rem;
    }
    .partner_item:nth-child(13) {
      width: 2.15rem;
      margin-right: 0.8rem;
    }
    .partner_item:nth-child(14) {
      width: 1.68rem;
      margin-right: 0.8rem;
    }
  }
  .parner_text {
    font-size: 0.18rem;
    color: #a8a6a5;
    text-align: center;
    margin-top: 0.3rem;
  }
}
</style>